import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalGenericoModel } from "src/app/shared/models/modal.model";
import { ReactivacionService } from "../../containers/bandeja-principal/administrador/gestion/reactivacion/reactivacion.service";

@Component({
  selector: "app-modal-asignar-reactivacion",
  templateUrl: "./modal-asignar-reactivacion.component.html",
  styleUrls: ["./modal-asignar-reactivacion.component.scss"],
})
export class ModalAsignarReactivacionComponent implements OnInit {
  @Input()
  modalGenerico: ModalGenericoModel;
  formAsignarReactivacion: FormGroup;
  estadosRNT: Array<any>;

  constructor(
    public formBuilder: FormBuilder,
    private activeModal: NgbActiveModal,
    public reactivacionService: ReactivacionService
  ) {}

  ngOnInit() {
    this.reactivacionService
      .getTipoSolicitudRNT({ tipo_solicitud: "REACTIVACION" })
      .subscribe((resultado) => {
        this.estadosRNT = resultado.data as Array<any>;
      });
    this.formAsignarReactivacion = this.formBuilder.group({
      tipo_reactivacion_id: [null, Validators.required],
    });
  }

  selecionarDato(item: any) {
    this.formAsignarReactivacion.controls["tipo_reactivacion_id"].setValue(
      item.tipo_solicitud_id
    );
  }

  dismiss(): void {
    if (this.activeModal) {
      this.activeModal.dismiss();
    }
  }

  sendForm(): void {
    if (this.activeModal) {
      this.activeModal.close(
        this.formAsignarReactivacion.value.tipo_reactivacion_id
      );
    }
  }
}
